<template>
    <div v-if="state" v-on-clickaway="closeFilters" class="filter-wrapper">
        <button
            class="filter-button"
            :class="{ 'filter-button--active': active }"
            @click="active = !active"
        >
            <svg class="icon"><use xlink:href="#filter-bars" /></svg>
            <span class="filter-label">Sort By</span>
            <svg class="icon"><use xlink:href="#arrow-down" /></svg>
        </button>

        <div v-show="active" class="filter-options">
            <p
                v-for="item in state.options"
                :key="item.value"
                class="small semi my-xs"
                :class="{ 'filter-active': item.value === state.currentRefinement }"
                @click="state.refine(item.value)"
            >
                {{ item.label }}
            </p>
        </div>
    </div>
</template>

<script>
import { startCase } from 'lodash';
import { createWidgetMixin } from 'vue-instantsearch';
import { connectSortBy } from 'instantsearch.js/es/connectors';
import { mixin as clickaway } from 'vue-clickaway';

export default {
    mixins: [clickaway, createWidgetMixin({ connector: connectSortBy })],

    data() {
        return {
            active: false
        };
    },

    computed: {
        widgetParams() {
            return {
                items: [
                    { value: 'retailers', label: 'Sort alphabetically' },
                    { value: 'retailers_signdate', label: 'Sort by signatory date' }
                ]
            };
        }
    },

    methods: {
        closeFilters() {
            this.active = false;
        },

        startCase(string) {
            return startCase(string);
        }
    }
};
</script>

<style lang="scss" scoped>
.filter-wrapper {
    position: relative;

    @media screen and (min-width: 769px) {
        margin: 0 2em;
    }
}

.filter-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 49px;
    border: 1px solid #dddddd;
    border-radius: 999px;
    font-weight: 500;
    font-size: 13px;
    padding: 0.5em 2em;
    outline: none;

    span {
        display: none;

        @media screen and (min-width: 1024px) {
            display: block;
        }
    }

    .icon {
        font-size: 20px;

        &:first-child {
            margin-right: 1em;
        }

        &:last-child {
            font-size: 10px;
            color: #ef6e0b;

            @media screen and (min-width: 1024px) {
                margin-left: 4em;
            }
        }
    }
}

.filter-button--active {
    border-color: #ef6e0b;
    background-color: #fff2e9;

    .icon {
        color: #ef6e0b;
    }
}

.filter-options {
    position: absolute;
    top: 100%;
    width: 300px;
    right: 0;
    margin-top: 1em;
    padding: 1em 1.5em;
    border: 1px solid #dddddd;
    background: #ffffff;
    z-index: 100;

    @media screen and (min-width: 769px) {
        width: 385px;
        right: auto;
    }

    p {
        cursor: pointer;
    }
}

.filter-option {
    margin-bottom: 2em;

    &:last-child {
        margin-bottom: 0;
    }
}

.filter-label {
    white-space: nowrap;
}

.filter-active {
    color: #ef6e0b;
}

.filter-count {
    display: flex;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 999px;
    margin-left: 2.75em;
    margin-right: -0.5em;
    background-color: #ef6e0b;
    color: #ffffff;
}

::v-deep {
    .ais-RefinementList-item {
        margin-bottom: 0.5em;
    }

    .ais-RefinementList-label {
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 13px;
    }

    .ais-RefinementList-checkbox {
        appearance: none;
        outline: none;
        border: 2px solid #ef6e0b;
        width: 20px;
        height: 20px;
        margin-right: 1em;
    }

    .ais-RefinementList-item--selected .ais-RefinementList-checkbox {
        background-image: url('/dist/images/tick.svg');
        background-size: 65%;
        background-repeat: no-repeat;
        background-position: 50% 50%;
    }

    .ais-RefinementList-count {
        display: none;
    }
}
</style>
